import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-dashboard" }
const _hoisted_2 = { class: "card bg-light" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "dashboard-links" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/logbook.svg",
  alt: "My Logbook Icon"
}, null, -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/assignment-dashboard.svg",
  alt: "My Assignments Icon"
}, null, -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/assessment.svg",
  alt: "My Assessment Icon"
}, null, -1)
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_help_modal = _resolveComponent("help-modal")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_help_modal, { ref: "helpModal" }, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "dashboard-link",
            to: 'logbook'
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createElementVNode("div", {
                class: "dashboard-link-text",
                innerHTML: _ctx.$t('pages.home.visitLogbook')
              }, null, 8, _hoisted_6)
            ]),
            _: 1
          }),
          (_ctx.assignmentsEnabled)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "dashboard-link",
                to: 'assignments'
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createElementVNode("div", {
                    class: "dashboard-link-text",
                    innerHTML: _ctx.$t('pages.home.visitAssignments')
                  }, null, 8, _hoisted_8)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.myIRLAEnabled)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "dashboard-link",
                to: 'myirla'
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createElementVNode("div", {
                    class: "dashboard-link-text",
                    innerHTML: _ctx.$t('pages.home.visitAssessment')
                  }, null, 8, _hoisted_10)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}